import omit from 'lodash/omit';
import React, { memo } from 'react';
import { Input } from '../Input';
import type { TextFieldProps } from './TextField.types';

export type { TextFieldProps };

export const TextField: React.FC<TextFieldProps> = memo((props) => {
  const { dataTestId = 'text-field' } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const selectionStart = event.target.selectionStart;
    props.onChangeValue?.(value);

    if ('changeByProp' in props) {
      props.onChange?.(props.changeByProp, value);
    } else {
      props.onChange?.({ value, selectionStart });
    }
  };

  const inputProps = omit(props, ['onChangeValue', 'onChange', 'changeByProp']);
  inputProps.className = props.className ?? '';
  inputProps.colorMode = props.colorMode ?? 'light';
  inputProps.inputStyle = props.inputStyle ?? {};
  inputProps.onKeyPress = props.onKeyPress ?? (() => null);
  inputProps.type = props.type ?? 'text';
  inputProps.value = props.value ?? '';

  return (
    <Input
      {...inputProps}
      className={`text-field ${props.className || ''}`}
      onChange={handleChange}
      ref={props.refFunc}
      data-testid={dataTestId}
    />
  );
});

// Display Name
TextField.displayName = 'TextField';

export default TextField;
